import React from 'react';
import { Link as MuiLink } from '@material-ui/core';
import { Link, LinkProps } from 'react-router-dom';

const MuiRouterLink = (props: LinkProps): JSX.Element => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <MuiLink component={Link} {...(props as any)} />
);

export default MuiRouterLink;
